<template>
  <v-list-item density="compact">
    <v-list-item-title class="dropdown-item">
      <div class="icon-wrapper">
        <slot name="icon">
          <app-icon-ds v-if="icon" :icon="icon" size="xs" />
          <v-img v-else-if="img" :src="img" />
        </slot>
      </div>
      <slot name="default">{{ label }}</slot>
    </v-list-item-title>
  </v-list-item>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AppDropdownButtonItem',
  props: {
    icon: {
      type: String,
      required: false,
    },
    img: {
      type: String,
      required: false,
    },
    label: {
      type: String,
      required: false,
    },
  },
})
</script>

<style scoped lang="scss">
.dropdown-item {
  display: flex;
  align-items: center;
  column-gap: 8px;

  .icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
  }
}
</style>
